"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("@package/utils");

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var FORM_NAME = 'create-shop';

var validate = function validate(values) {
  var errors = {};

  if (!values['name']) {
    errors['name'] = 'Обязательное поле';
  }

  if (values['webSite']) {
    if (!/^(http|https):\/\//.test(values['webSite'])) {
      errors['webSite'] = 'Неверный формат (http[s]://some-site)';
    } else if (/[&<>"']/g.test(values['webSite'])) {
      errors['webSite'] = 'Недопустимый символ';
    }
  }

  if (!values['supportPhone']) {
    errors['supportPhone'] = 'Обязательное поле';
  }

  if (!values['supportEmail']) {
    errors['supportEmail'] = 'Обязательное поле';
  } else {
    if (!_utils.validation.email(values['supportEmail'])) {
      errors['supportEmail'] = 'Неверный формат email';
    }
  }

  return errors;
};

var _default = (0, _reduxForm.reduxForm)({
  form: FORM_NAME,
  validate: validate
})(_Component["default"]);

exports["default"] = _default;